export default "__VITE_ASSET__ac796cea__"